module.exports = __WEBPACK_EXTERNAL_MODULE_babylonjs_Maths_math_vector__;